<template>
  <div class="d-flex justify-center flex-wrap pt-4 ga-4">
    <p
    class="ma-0"
    style="font-size: 20px; padding-left: 1px; font-style: italic; color: rgb(var(--v-theme-primary)) !important">
    A new app update has been downloaded. Would you like to apply it now?
  </p>
  <Button
  class="w-100"
  :slim="true"
  version="primary"
  :label="btn_1_content"
  @click="applyUpdate(version)"
  />
</div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

import Button from '@/components/ComponentLibrary/Button.vue';
import { applyUpdate } from '@/services/mobile_app/liveUpdateService';
import { BundleInfo } from '@capgo/capacitor-updater';

const btn_1_content = ref('Apply Update Now');

const props = defineProps<{
  version: BundleInfo;
}>();

</script>

<style lang="scss">

</style>